export default function MySQL_UCASE() {
  return (
    <div>
      <h2>MySQL_UCASE</h2>    </div>
  );
}